import React, { useMemo } from 'react'
import { Source, Layer } from 'react-map-gl/mapbox'

export const CLUSTER_ZOOM_THRESHOLD = 8

function MapClusterLayer({ nodes, themeMode }) {
  const isDark = themeMode === 'dark'

  const geojson = useMemo(() => ({
    type: 'FeatureCollection',
    features: nodes
      .filter(n => n.data.lat != null && n.data.lng != null)
      .map(n => ({
        type: 'Feature',
        properties: { id: n.id },
        geometry: { type: 'Point', coordinates: [n.data.lng, n.data.lat] },
      })),
  }), [nodes])

  return (
    <Source
      id="cluster-nodes"
      type="geojson"
      data={geojson}
      cluster={true}
      clusterMaxZoom={CLUSTER_ZOOM_THRESHOLD - 1}
      clusterRadius={50}
    >
      {/* Outer glow behind cluster bubble */}
      <Layer
        id="clusters-glow"
        type="circle"
        maxzoom={CLUSTER_ZOOM_THRESHOLD}
        filter={['has', 'point_count']}
        paint={{
          'circle-color': isDark ? '#818cf8' : '#4f46e5',
          'circle-radius': ['step', ['get', 'point_count'], 28, 5, 36, 15, 44],
          'circle-opacity': 0.18,
          'circle-blur': 0.8,
        }}
      />
      {/* Cluster bubble */}
      <Layer
        id="clusters"
        type="circle"
        maxzoom={CLUSTER_ZOOM_THRESHOLD}
        filter={['has', 'point_count']}
        paint={{
          'circle-color': isDark ? '#4f46e5' : '#6366f1',
          'circle-radius': ['step', ['get', 'point_count'], 18, 5, 24, 15, 30],
          'circle-stroke-width': 2.5,
          'circle-stroke-color': isDark ? '#a5b4fc' : '#c7d2fe',
          'circle-opacity': 0.92,
        }}
      />
      {/* Cluster count label */}
      <Layer
        id="cluster-count"
        type="symbol"
        maxzoom={CLUSTER_ZOOM_THRESHOLD}
        filter={['has', 'point_count']}
        layout={{
          'text-field': '{point_count_abbreviated}',
          'text-size': 13,
          'text-allow-overlap': true,
        }}
        paint={{ 'text-color': '#ffffff' }}
      />
      {/* Invisible layer for individual node querying — used to detect unclustered node IDs */}
      <Layer
        id="unclustered-points-query"
        type="circle"
        maxzoom={CLUSTER_ZOOM_THRESHOLD}
        filter={['!', ['has', 'point_count']]}
        paint={{
          'circle-radius': 0,
          'circle-opacity': 0,
        }}
      />
    </Source>
  )
}

export default React.memo(MapClusterLayer)
